module.exports = __webpack_public_path__ + "img/word-card-app.fd38d94a.png";